module.exports = __webpack_public_path__ + "static/media/smarking.d4585d47.jpg";